"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetAttackPositions = void 0;
exports.findEnemyInAttackRange = findEnemyInAttackRange;
const board_1 = require("@creature-chess/board");
const isInsideGrid = ({ width, height }) => (position) => {
    const [x, y] = (0, board_1.unpackPosition)(position);
    return x >= 0 && y >= 0 && x < width && y < height;
};
function findEnemyInAttackRange(board, pieceRegistry, friendlyOwnerId, piecePosition, range = 1) {
    const attackPositions = (0, exports.getTargetAttackPositions)({ width: board.width, height: board.height }, piecePosition, range);
    for (const position of attackPositions) {
        const [x, y] = (0, board_1.unpackPosition)(position);
        const pieceId = board.getPieceIdAtPosition(x, y);
        if (!pieceId) {
            continue;
        }
        const piece = pieceRegistry.getPieceById(pieceId);
        if (!piece || piece.ownerId === friendlyOwnerId) {
            continue;
        }
        return { piece, position };
    }
    return null;
}
/**
 * Finds all positions from which a piece can attack the given position.
 *
 * @param size The size of the board.
 * @param position The position of the target piece.
 * @param range The attack range of the attacking piece.
 * @returns An array of positions from which the piece can attack the target position.
 */
const getTargetAttackPositions = (size, position, range = 1) => {
    const positions = [];
    const [positionX, positionY] = (0, board_1.unpackPosition)(position);
    for (let x = positionX - range; x <= positionX + range; x++) {
        if (x === positionX) {
            continue;
        }
        positions.push((0, board_1.packPosition)(x, positionY));
    }
    for (let y = positionY - range; y <= positionY + range; y++) {
        if (y === positionY) {
            continue;
        }
        positions.push((0, board_1.packPosition)(positionX, y));
    }
    // filter out any that are outside the grid
    return positions.filter(isInsideGrid(size));
};
exports.getTargetAttackPositions = getTargetAttackPositions;
